module.exports = __webpack_public_path__ + "img/google-play-btn.d45e8b1a.svg";